<template>
  <div class="animated fadeIn">
    <template v-if="formEmpty === true">
      <div class="bg-primary mb-15 p-10 text-center">Complete EHA Form to Convert</div>
    </template>
    <template v-if="formEmpty === false && isTrueData() === false">
      <div class="bg-primary mb-15 p-10 text-center">Please complete all leads information before convert to member!
      </div>
    </template>
    <div class="text-right mb-15">
      <template v-if="isBlacklist">
        <a v-if="!isViewOnly" @click="setBlackList(0)" class="btn btn-outline-danger mr-10">Cancel Blacklist</a>
      </template>
      <template v-else>
        <a v-if="!isViewOnly" @click="setBlackList(1)" class="btn btn-outline-danger mr-10">Blacklist</a>
      </template>
      <template v-if="formEmpty === false && dataMember.is_member === false">
        <a v-if="isTrueData() === true" @click="convertMember()" class="btn-primary mr-10">Convert</a>
        <button v-if="isTrueData() === false" class="btn-primary mr-10" disabled>Convert</button>
      </template>
      <template v-if="formEmpty === false && dataMember.is_member === true">
        <template v-if="(dataTransaction.length === 0)">
          <a @click="openPage('/leads/convert?id=' + id_lead)" class="btn-primary mr-10">Convert</a>
        </template>
        <template v-else>
          <a @click="showModal('transactionModal')" class="btn-secondary mr-10">View Transaction</a>
          <span v-if="!(dataMember.leads_status.id == 2)">
            <a @click="openPage('/leads/checkout?id=' + id_lead)" class="btn-primary mr-10">Card Registration</a>
          </span>
        </template>
      </template>
      <!-- v-if="dataMember.is_member === false" disabled walaupun sudah jadi member request by adyt -->
      <a @click="openPage('/leads/edit?id=' + id_lead)"
        class="btn-border-primary mr-10">Edit</a>
      <a @click="openPage('/leads/eha?id=' + id_lead)" class="btn-border-primary">EHA Form</a>
    </div>
    <div class="box-mini mb-30">
      <div class="p-30">
        <div class="mb-20">
          <table>
            <tr>
              <td>
                <img class="img-circle-70 box-shadow mr-15" src="/placeholder.png" alt />
              </td>
              <td>
                <h1 class="mb-0 font-400 color-secondary">{{ dataMember.first_name }} {{ dataMember.last_name }}</h1>
              </td>
            </tr>
          </table>
        </div>
        <b-row class="mb-10">
          <b-col sm="3">
            <div class="color-secondary">Lead Owner</div>
          </b-col>
          <b-col sm="9">
            <div>{{ salesName }}</div>
          </b-col>
        </b-row>
        <b-row class="mb-10">
          <b-col sm="3">
            <div class="color-secondary">Email</div>
          </b-col>
          <b-col sm="9">
            <div>{{ dataMember.email }}</div>
          </b-col>
        </b-row>
        <b-row class="mb-10">
          <b-col sm="3">
            <div class="color-secondary">ID Card</div>
          </b-col>
          <b-col sm="9">
            <div>{{ dataMember.no_ktp }}</div>
          </b-col>
        </b-row>
        <b-row class="mb-10">
          <b-col sm="3">
            <div class="color-secondary">Phone Number</div>
          </b-col>
          <b-col sm="9">
            <div>{{ dataMember.phone_country_code }} {{ dataMember.phone_number }}</div>
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col sm="3">
            <div class="color-secondary">Home Number</div>
          </b-col>
          <b-col sm="9">
            <div>{{ dataMember.home_number }}</div>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- start activities -->
    <div class="mb-20">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">Activities</div>
        </div>
        <div class="col-sm-6 text-right">
          <template v-if="!(items.length === 0) && (leadsFlow != null && leadsFlow.is_btn_appoitment == 1)">
            <template v-if="leadsFlow.is_btn_appoitment == 1">
              <a @click="showModal('new-appointment')" class="font-bold color-primary mb-10 mr-15">+ Appointment</a>
            </template>
          </template>
          <a @click="showModal('new-call')" class="font-bold color-primary mb-10">+ Call</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
            :fixed="fixed" responsive="sm" :items="items" :fields="fields">
            <template v-slot:cell(start_time)="data">
              <!--            <template slot="start_time" slot-scope="data">-->
              {{ cutTime(data.item.start_time) }}
            </template>
            <template v-slot:cell(due_date)="data">
              <!--            <template slot="due_date" slot-scope="data">-->
              {{ parseDateTime(data.item.due_date) }}
            </template>
            <template v-slot:cell(updated_at)="data">
              <!--            <template slot="updated_at" slot-scope="data">-->
              {{ parseDateTime(data.item.updated_at) }}
            </template>
            <template v-slot:cell(status)="data">
              <!--            <template slot="status" slot-scope="data">-->
              <b-badge :variant="getBadge(data.item.status)">{{ data.item.status }}</b-badge>
            </template>
            <template v-slot:cell(activities_status)="data">
              <!--            <template slot="activities_status" slot-scope="data">-->
              <template v-if="data.item.leads_activities_status.name == 'Verified'">
                <span v-if="(data.item.appointment_status == 'show')">Show</span>
                <span v-if="(data.item.appointment_status == 'notShow')">Not Show</span>
                <span v-if="(data.item.appointment_show_status == 'missedGuest')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>Missed Guest
                </span>
                <span v-if="(data.item.appointment_show_status == 'member')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>Member
                </span>
                <span v-if="(data.item.appointment_missed_guest_status == 'guestPassIssued')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>Guest Pass Issued
                </span>
                <span v-if="(data.item.appointment_missed_guest_status == 'noGuestPassIssued')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>No Guest Pass Issued
                </span>
              </template>
              <template v-else>-</template>
            </template>
            <!--            <template slot="action" slot-scope="data">-->
            <template v-slot:cell(action)="data">
              <template v-if="data.item.leads_activity_status_id == 4 || data.item.leads_activity_status_id == 9">
                <b-button size="sm" @click="editAppointmentModal('edit-appointment', data.item.id)"
                  class="btn-table green mr-1">
                  <i class="fas fa-bell"></i> Change
                </b-button>
              </template>
              <template v-else>
                -
                <!-- <b-button size="sm" @click="editCallModal('edit-call', data.item.id)" class="btn-table green mr-1">
                  <i class="fas fa-bell"></i> Change
                </b-button>-->
              </template>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
            @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
        </div>
      </div>
    </div>
    <div class="modal-section">
      <!-- detail transaction section -->
      <b-modal modal-class="modal-custom-image" hide-footer :ref="'transactionModal'" centered
        title="Transaction Detail">
        <div class="p-10" v-for="itemTransaction in dataTransaction" :key="itemTransaction.id">
          <table class="table w-100">
            <tr>
              <td>Membership Name</td>
              <td>{{ itemTransaction.membership_name }}</td>
            </tr>
            <tr>
              <td>Membership Monthly price</td>
              <td>{{ itemTransaction.membership_price }}</td>
            </tr>
            <tr>
              <td>Total Payment</td>
              <td>{{ itemTransaction.gross_amount }}</td>
            </tr>
            <tr>
              <td>Payment Type 1</td>
              <td>
                <template v-for="paymentType1 in itemsPaymentType">
                  <template v-if="paymentType1.id == itemTransaction.payment_type_id_1">{{ paymentType1.name }}</template>
                </template>
              </td>
            </tr>
            <tr>
              <td>Payment Card 1</td>
              <td>
                <template v-for="paymentCard1 in itemsPaymentCard">
                  <template v-if="paymentCard1.id == itemTransaction.payment_card_id_1">{{ paymentCard1.name }}</template>
                </template>
              </td>
            </tr>
            <tr>
              <td>Payment Amount 1</td>
              <td>{{ itemTransaction.payment_amount_1 }}</td>
            </tr>
            <tr v-if="!(itemTransaction.payment_type_id_2 == null)">
              <td>Payment Type 2</td>
              <td>
                <template v-for="paymentType2 in itemsPaymentType">
                  <template v-if="paymentType2.id == itemTransaction.payment_type_id_2">{{ paymentType2.name }}</template>
                </template>
              </td>
            </tr>
            <tr v-if="!(itemTransaction.payment_card_id_2 == null)">
              <td>Payment Card 2</td>
              <td>
                <template v-for="paymentCard2 in itemsPaymentCard">
                  <template v-if="paymentCard2.id == itemTransaction.payment_card_id_2">{{ paymentCard2.name }}</template>
                </template>
              </td>
            </tr>
            <tr v-if="!(itemTransaction.payment_amount_2 == 0)">
              <td>Payment Amount 2</td>
              <td>{{ itemTransaction.payment_amount_2 }}</td>
            </tr>
            <tr>
              <td>Notes</td>
              <td>
                <textarea class="form-control w-100 mb-10" rows="5" v-model="itemTransaction.notes" name="notes"
                  type="text" />
                <b-button @click="saveNote">Save Notes</b-button>
              </td>
            </tr>
          </table>
          <hr class="short-line left mb-10 mt-20" />
        </div>
      </b-modal>
      <!-- call section -->
      <b-modal modal-class="modal-custom-input" hide-footer :ref="'new-call'" centered title="Create Fresh Call">
        <div class="box-shadow p-15">
          <div class="font-500">Activity Information</div>
          <hr class="short-line left mb-15" />
          <form @submit="validateCall('activityNewCall')" data-vv-scope="activityNewCall">
            <div class="mb-10">
              <div class="font-13 mb-5">Date of Call</div>
              <flat-pickr :config="config" disabled v-model="addCall.due_date" class="w-100"></flat-pickr>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Activity Type</div>
              <b-form-select name="leads_activity_type" v-validate="'required'" v-model="addCall.leads_activity_type_id"
                class="form-control">
                <option value="null">Please select</option>
                <template v-for="item in data1">
                  <option :key="item.id" :value="item.id" v-if="!(item.id == '4')">{{ item.name }}</option>
                </template>
              </b-form-select>
              <span class="error">{{ errors.first('activityNewCall.leads_activity_type') }}</span>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Status</div>
              <b-form-select name="leads_activity_status" v-model="addCall.leads_activity_status_id"
                class="form-control">
                <option value="null">Please select</option>
                <option v-for="item in data2" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Next Schedule Date</div>
              <div class="select-time">
                <flat-pickr :config="config" v-model="addCall.next_schedule_call_date" name="next_schedule_call_date"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Next Schedule Time</div>
              <div class="select-time">
                <flat-pickr :config="config2" v-model="addCall.next_schedule_call_time" name="next_schedule_call_time"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Notes</div>
              <b-form-input class="form-control" v-model="addCall.notes" name="notes" type="text"></b-form-input>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Call Time</div>
              <div class="select-time">
                <flat-pickr :config="config2" v-model="addCall.start_time" name="time_start" class="w-100"></flat-pickr>
              </div>
            </div>
            <hr class="transparent" />
            <div class="text-center">
              <button v-if="!isViewOnly" @click="validateCall('activityNewCall')" type="submit" class="btn-primary mr-10" ref="newCall">
                <span ref="submitNewCall">Submit</span>
                <span ref="spinnerNewCall" class="hidden">
                  <b-spinner small></b-spinner>Submit
                </span>
              </button>
              <a @click="hideModal('new-call')" class="btn-border-primary">Close</a>
            </div>
          </form>
        </div>
      </b-modal>
      <b-modal modal-class="modal-custom-input" hide-footer :ref="'edit-call'" centered title="Edit Call">
        <div class="box-shadow p-15">
          <div class="font-500">Activity Information</div>
          <hr class="short-line left mb-15" />
          <form @submit.prevent="validateCallEdit('activityEditCall')" data-vv-scope="activityEditCall">
            <div class="mb-10">
              <div class="font-13 mb-5">Date of Call</div>
              <flat-pickr :config="config" disabled v-model="editCall.due_date" class="w-100"></flat-pickr>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Activity Type</div>
              <b-form-select name="leads_activity_type" v-validate="'required'"
                v-model="editCall.leads_activity_type_id" class="form-control">
                <option value="null">Please select</option>
                <option v-for="item in data1" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
              <span class="error">{{ errors.first('activityEditCall.leads_activity_type') }}</span>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Status</div>
              <b-form-select name="leads_activity_type" v-model="editCall.leads_activity_status_id"
                class="form-control">
                <option value="null">Please select</option>
                <option v-for="item in data2" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Next Schedule Date</div>
              <div class="select-time">
                <flat-pickr :config="config" v-model="editCall.next_schedule_call_date" name="next_schedule_call_date"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Next Schedule Time</div>
              <div class="select-time">
                <flat-pickr :config="config2" v-model="editCall.next_schedule_call_time" name="next_schedule_call_time"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Notes</div>
              <b-form-input class="form-control" v-model="editCall.notes" name="notes" type="text"></b-form-input>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Call Time</div>
              <div class="select-time">
                <flat-pickr :config="config2" v-model="editCall.start_time" name="time_start"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <hr class="transparent" />
            <div class="text-center">
              <button v-if="!isViewOnly" type="submit" class="btn-primary mr-10" ref="editCall">
                <span ref="submitEditCall">Submit</span>
                <span ref="spinnerEditCall" class="hidden">
                  <b-spinner small></b-spinner>Submit
                </span>
              </button>
              <a @click="hideModal('edit-call')" class="btn-border-primary">Close</a>
            </div>
          </form>
        </div>
      </b-modal>
      <!-- appointment section -->
      <b-modal modal-class="modal-custom-input" hide-footer :ref="'new-appointment'" centered
        title="Create Appointment">
        <div class="box-shadow p-15">
          <div class="font-500">Activity Information</div>
          <hr class="short-line left mb-15" />
          <form @submit.prevent="validateAppointment('activityAppointment')" data-vv-scope="activityAppointment">
            <div class="mb-10">
              <div class="font-13 mb-5">Activity Type</div>
              <b-form-select name="leads_activity_type" v-model="addAppointment.leads_activity_type_id" disabled
                class="form-control bg-transparent">
                <option value="null">Please select</option>
                <option v-for="item in data1" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Status</div>
              <b-form-select name="leads_activity_type" v-model="addAppointment.leads_activity_status_id"
                class="form-control">
                <option value="null">Please select</option>
                <option v-for="item in data3" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
            <template v-if="addAppointment.leads_activity_status_id === 4">
              <div class="mb-10">
                <div class="font-13 mb-5">Appointment Status</div>
                <b-form-select v-model="addAppointment.appointment_status" class="form-control">
                  <option value="null">Please select</option>
                  <option value="show">Show</option>
                  <option value="notShow">Not Show</option>
                </b-form-select>
              </div>
            </template>
            <template v-if="addAppointment.appointment_status === 'show'">
              <div class="mb-10">
                <div class="font-13 mb-5">Appointment Show Status</div>
                <b-form-select v-model="addAppointment.appointment_show_status" class="form-control">
                  <option value="null">Please select</option>
                  <option value="member">Member</option>
                  <option value="missedGuest">Missed Guest</option>
                </b-form-select>
              </div>
            </template>
            <template v-if="addAppointment.appointment_show_status === 'missedGuest'">
              <div class="mb-10">
                <div class="font-13 mb-5">Appointment Missed Guest Status</div>
                <b-form-select v-model="addAppointment.appointment_missed_guest_status" class="form-control">
                  <option value="null">Please select</option>
                  <option value="guestPassIssued">Guest Pass Issued</option>
                  <option value="noGuestPassIssued">No Guest Pass Issued</option>
                </b-form-select>
              </div>
            </template>
            <div class="mb-10">
              <div class="font-13 mb-5">Notes</div>
              <b-form-input class="form-control" v-model="addAppointment.notes" name="notes" type="text"></b-form-input>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Time</div>
              <div class="select-time">
                <flat-pickr :config="config2" v-model="addAppointment.start_time" name="time_start"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Date</div>
              <flat-pickr :config="config" v-model="addAppointment.due_date" class="w-100"></flat-pickr>
            </div>
            <hr class="transparent" />
            <div class="text-center">
              <button type="submit" class="btn-primary mr-10" ref="newAppointment">
                <span ref="submitNewAppointment">Submit</span>
                <span ref="spinnerNewAppointment" class="hidden">
                  <b-spinner small></b-spinner>Submit
                </span>
              </button>
              <a @click="hideModal('new-appointment')" class="btn-border-primary">Close</a>
            </div>
          </form>
        </div>
      </b-modal>
      <b-modal modal-class="modal-custom-input" hide-footer :ref="'edit-appointment'" centered title="Edit Appointment">
        <div class="box-shadow p-15">
          <div class="font-500">Activity Information</div>
          <hr class="short-line left mb-15" />
          <form @submit.prevent="validateAppointmentEdit('activityEditAppointment')"
            data-vv-scope="activityEditAppointment">
            <div class="mb-10">
              <div class="font-13 mb-5">Activity Type</div>
              <b-form-select name="leads_activity_type" v-model="editAppointment.leads_activity_type_id" disabled
                class="form-control bg-transparent">
                <option value="null">Please select</option>
                <option v-for="item in data1" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Status</div>
              <b-form-select name="leads_activity_type" v-model="editAppointment.leads_activity_status_id"
                class="form-control">
                <option value="null">Please select</option>
                <option v-for="item in data3" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
            <template v-if="editAppointment.leads_activity_status_id === 4">
              <div class="mb-10">
                <div class="font-13 mb-5">Appointment Status</div>
                <b-form-select v-model="editAppointment.appointment_status" class="form-control">
                  <option value="null">Please select</option>
                  <option value="show">Show</option>
                  <option value="notShow">Not Show</option>
                </b-form-select>
              </div>
            </template>
            <template v-if="editAppointment.appointment_status === 'show'">
              <div class="mb-10">
                <div class="font-13 mb-5">Appointment Show Status</div>
                <b-form-select v-model="editAppointment.appointment_show_status" class="form-control">
                  <option value="null">Please select</option>
                  <option value="member">Member</option>
                  <option value="missedGuest">Missed Guest</option>
                </b-form-select>
              </div>
            </template>
            <template v-if="editAppointment.appointment_show_status === 'missedGuest'">
              <div class="mb-10">
                <div class="font-13 mb-5">Appointment Missed Guest Status</div>
                <b-form-select v-model="editAppointment.appointment_missed_guest_status" class="form-control">
                  <option value="null">Please select</option>
                  <option value="guestPassIssued">Guest Pass Issued</option>
                  <option value="noGuestPassIssued">No Guest Pass Issued</option>
                </b-form-select>
              </div>
            </template>
            <div class="mb-10">
              <div class="font-13 mb-5">Notes</div>
              <b-form-input class="form-control" v-model="editAppointment.notes" name="notes"
                type="text"></b-form-input>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Time</div>
              <div class="select-time">
                <flat-pickr :config="config2" v-model="editAppointment.start_time" name="time_start"
                  class="w-100"></flat-pickr>
              </div>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Date</div>
              <flat-pickr :config="config" v-model="editAppointment.due_date" class="w-100"></flat-pickr>
            </div>
            <hr class="transparent" />
            <div class="text-center">
              <button type="submit" class="btn-primary mr-10" ref="editAppointment">
                <span ref="submitEditAppointment">Submit</span>
                <span ref="spinnerEditAppointment" class="hidden">
                  <b-spinner small></b-spinner>Submit
                </span>
              </button>
              <a @click="hideModal('edit-appointment')" class="btn-border-primary">Close</a>
            </div>
          </form>
        </div>
      </b-modal>
      <div v-if="loadingActive == true" class="loading-container">
        <div class="wrap-screen w-100 h-100">
          <img :src="`/svg-loaders/oval.svg`" width="60" alt />
          <div class="title-loading color-white">Please Wait...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";
import editVue from '../classCategory/edit.vue';

export default {
  name: "leads",
  components: {
    "app-pagination": Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fields: [
        {
          key: "leads_activities_type.name",
          label: "Activity Type",
          sortable: true
        },
        {
          key: "leads_activities_status.name",
          label: "Status",
          sortable: true
        },
        {
          key: "activities_status",
          label: "Appointment Status",
          sortable: true
        },
        // {
        //   key: 'appointment_status',
        //   label: 'Appointment Status',
        //   sortable: true
        // },
        // {
        //   key: 'appointment_show_status',
        //   label: 'Appointment Show Status',
        //   sortable: true
        // },
        // {
        //   key: 'appointment_missed_guest_status',
        //   label: 'Appointment Missed Guest Status',
        //   sortable: true
        // },
        {
          key: "notes",
          label: "Notes",
          sortable: true
        },
        {
          key: "date_agenda",
          label: "Agenda",
          sortable: true,
          formatter: (value, key, item) => {
            return item.leads_activity_type_id == 2 || item.leads_activity_type_id == 6 ? moment(item.next_schedule_call_date).format("DD-MM-YYYY") : moment(item.due_date).format("DD-MM-YYYY");
          }
        },
        {
          key: "start_time",
          label: "Activity Time",
          sortable: true
        },
        {
          key: "sales_owner.fullname",
          label: "Activity Owner",
          sortable: true
        },
        {
          key: "updated_at",
          label: "Modified Owner",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: true
        }
      ],
      loadingActive: false,
      validateInterested: "",
      isBlacklist: false,
      isViewOnly: false,
      config: {},
      config2: {
        enableTime: true,
        noCalendar: true,
        defaultDate: "00:00",
        static: true,
        time_24hr: true
      },
      updateData: {
        is_member: 1,
        leads_status_id: 4
      },
      formEmpty: "",
      addCall: {
        leads_id: "",
        subject: "",
        notes: "",
        leads_activity_type_id: null,
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: moment(new Date()).format("YYYY-MM-DD"),
        start_time: moment(new Date()).format("HH:mm"),
        next_schedule_call_date: moment(new Date()).format("YYYY-MM-DD"),
        next_schedule_call_time: "07:00",
      },
      editCall: {
        leads_id: "",
        subject: "",
        leads_activity_type_id: null,
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: "",
        start_time: "",
        next_schedule_call_date: "",
        next_schedule_call_time: "",
      },
      addAppointment: {
        leads_id: "",
        subject: "",
        leads_activity_type_id: "4",
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: moment(new Date()).format("YYYY-MM-DD"),
        start_time: "07:00",
        appointment_status: null,
        appointment_show_status: null,
        appointment_missed_guest_status: null
      },
      editAppointment: {
        leads_id: "",
        subject: "",
        leads_activity_type_id: "4",
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: "",
        start_time: "",
        appointment_status: null,
        appointment_show_status: null,
        appointment_missed_guest_status: null
      },
      itemsPaymentCard: [],
      itemsPaymentType: [],
      id_lead: "",
      dataTransaction: [],
      getActivityId: "",
      data1: [],
      data2: [],
      data3: [],
      scheduler: {
        email: ""
      },
      dataLeads: [],
      salesName: "",
      dataMember: [],
      dateWeek: "",
      leadsFlow: null,
      items: [],
      sortType: "",
      sortBy: "",
      searchData: "",
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getDocType: "",
      regisPrivy: {
        leads_id: ""
      }
    };
  },
  methods: {
    loadingView() {
      this.loadingActive = false;
    },
    isTrueData() {
      if (
        this.dataLeads.first_name &&
        this.dataLeads.birthday &&
        this.dataLeads.email &&
        this.dataLeads.no_ktp &&
        this.dataLeads.birthday &&
        this.dataLeads.gender &&
        this.dataLeads.phone_number &&
        this.dataLeads.home_number &&
        this.dataLeads.emergency_contact &&
        this.dataLeads.emergency_number &&
        this.dataLeads.address
      ) {
        return true;
      } else {
        return false;
      }
    },
    convertMember(event) {
      this.$swal({
        title: "Are you sure?",
        text: "You will convert this lead to member",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Convert this lead!",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          this.loadingActive = true;


          axios
            .put("crm/v1/leads/" + this.$route.query.id, this.updateData)
            .then(response => {
              console.log({ response });
              axios.defaults.headers.post["Content-Type"] =
                "multipart/form-data";
              var data = new FormData();

              data.append("first_name", this.dataMember.first_name);
              data.append("last_name", this.dataMember.last_name);
              data.append("phone_number", this.dataMember.phone_number);
              data.append("email", this.dataMember.email);
              data.append("new_password", "paradigm1234");
              data.append("confirm_password", "paradigm1234");

              data.append("sales_id", this.dataMember.owner_id);
              data.append("source_id", this.dataMember.source_type_id);
              data.append("id_card", this.dataMember.no_ktp);

              data.append("home_number", this.dataMember.home_number);
              data.append("birthday", this.dataMember.birthday);
              data.append("gender_id", this.dataMember.gender);
              data.append("address", this.dataMember.address);
              data.append("current_address", this.dataMember.current_address);
              data.append("referral_pt_id", this.dataMember.referral_pt_id);
              data.append(
                "emergency_contact",
                this.dataMember.emergency_contact
              );
              data.append("emergency_number", this.dataMember.emergency_number);

              this.scheduler.email = this.dataMember.email;

              // console.log({newData});
              //data.append('privy_id', this.dataMember.privy_id)

              const raw = `crm/v1/leads/convert_leads`;
              axios
                .post(raw, data, {
                  headers: {
                    "X-Access-Token": Auth.Session.get().paradigm_token,
                    "X-Requested-With": 'XMLHttpRequest'
                  }
                })
                .then(response => {
                  this.loadingActive = false;
                  this.$swal(
                    "Success",
                    "You successfully convert this lead to member",
                    "success"
                  );
                  this.$router.push("/leads/convert?id=" + this.id_lead);
                })
                .catch(error => {
                  this.loadingActive = false;
                  this.$toast.success("Member Registration Error!", "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                  console.log('error', error)
                });
            })
            .catch(error => {
              this.loadingActive = false;
              this.$toast.success("Update Lead Data Error!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              console.log('error', error)
            });
        } else {
          this.$swal("Cancelled", "Cancel convert to member", "info");
        }
      });
    },
    async saveNote() {
      try {
        let res = await axios.put(
          "transaction/v1/transaction/detail?id=" + this.dataTransaction[0].id,
          { notes: this.dataTransaction[0].notes }
        );
        this.$toast.success("data saved successfully!", "Success", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
        this.$router.push("/leads");
      } catch (error) {
        this.$toast.success("cant saved data!", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      }
    },
    setBlackList(value) {
      const info = this.isBlacklist ? "You will Blacklist this lead!" : "You will Cancel Blacklist this lead!";
      this.$swal({
        title: "Are you sure?",
        text: info,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          // console.log('test',  {
          //     leads_id: Number(this.id_lead),
          //     is_blacklist: value
          //   })
          axios
            .post("crm/v1/leads/blacklist_leads", {
              leads_id: this.id_lead,
              is_blacklist: value
            })
            .then(response => {
              this.$toast.success("Successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.$router.push("/leads");
            }).catch(error => {
              this.$toast.success("Error!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
        }
      });
    },
    activeSpinner(value1, value2, value3) {
      this.$refs[value1].disabled = true;
      this.$refs[value1].classList.add("custom-disabled");
      this.$refs[value2].classList.add("hidden");
      this.$refs[value3].classList.remove("hidden");
    },
    disableSpinner(value1, value2, value3) {
      this.$refs[value1].disabled = false;
      this.$refs[value1].classList.remove("custom-disabled");
      this.$refs[value2].classList.remove("hidden");
      this.$refs[value3].classList.add("hidden");
    },
    validateCall(scope) {
      console.log("test")
      this.activeSpinner("newCall", "submitNewCall", "spinnerNewCall");
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.loadingActive = true
          this.addCall.leads_id = this.id_lead;
          axios
            .post("crm/v1/leads_activities/", this.addCall)
            .then(response => {
              this.loadingActive = false
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("new-call");
              this.fetchData();
              this.addCall.leads_id = "";
              this.addCall.notes = "";
              this.addCall.leads_activity_type_id = null;
              this.addCall.leads_activity_status_id = null;
              this.addCall.leads_source_type_id = "1";
              this.addCall.due_date = moment(new Date()).format("YYYY-MM-DD");
              this.addCall.start_time = "07:00";
              this.disableSpinner("newCall", "submitNewCall", "spinnerNewCall");
            })
            .catch(error => {
              this.loadingActive = false
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner("newCall", "submitNewCall", "spinnerNewCall");
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner("newCall", "submitNewCall", "spinnerNewCall");
        }
      });
    },
    validateCallEdit(scope) {
      this.activeSpinner("editCall", "submitEditCall", "spinnerEditCall");
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.editCall.leads_id = this.id_lead;
          axios
            .put("crm/v1/leads_activities/" + this.getActivityId, this.editCall)
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("edit-call");
              this.fetchData();
              this.disableSpinner(
                "editCall",
                "submitEditCall",
                "spinnerEditCall"
              );
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner(
                "editCall",
                "submitEditCall",
                "spinnerEditCall"
              );
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner("editCall", "submitEditCall", "spinnerEditCall");
        }
      });
    },
    validateAppointment(scope) {
      this.activeSpinner(
        "newAppointment",
        "submitNewAppointment",
        "spinnerNewAppointment"
      );
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.addAppointment.leads_id = this.id_lead;
          axios
            .post("crm/v1/leads_activities/", this.addAppointment)
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("new-appointment");
              this.fetchData();
              this.disableSpinner(
                "newAppointment",
                "submitNewAppointment",
                "spinnerNewAppointment"
              );
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner(
                "newAppointment",
                "submitNewAppointment",
                "spinnerNewAppointment"
              );
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner(
            "newAppointment",
            "submitNewAppointment",
            "spinnerNewAppointment"
          );
        }
      });
    },
    validateAppointmentEdit(scope) {
      this.activeSpinner(
        "editAppointment",
        "submitEditAppointment",
        "spinnerEditAppointment"
      );
      this.$validator.validateAll(scope).then(async result => {
        if (result) {
          this.editAppointment.leads_id = this.id_lead;
          if (this.editAppointment.appointment_status === "notShow") {
            this.editAppointment.appointment_show_status = null;
            this.editAppointment.appointment_missed_guest_status = null;
          }
          if (this.editAppointment.appointment_show_status === "member") {
            this.editAppointment.appointment_missed_guest_status = null;
          }
          let { id, ...new_data } = this.editAppointment
          axios
            .post("crm/v1/leads_activities/", new_data)
          let edit = {
            leads_activity_status_id: 8
          }
          axios
            .put(
              "crm/v1/leads_activities/" + id,
              edit
            )
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("edit-appointment");
              this.fetchData();
              this.disableSpinner(
                "editAppointment",
                "submitEditAppointment",
                "spinnerEditAppointment"
              );
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner(
                "editAppointment",
                "submitEditAppointment",
                "spinnerEditAppointment"
              );
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner(
            "editAppointment",
            "submitEditAppointment",
            "spinnerEditAppointment"
          );
        }
      });
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    enterClicked(searchEvent) {
      this.fetchData();
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
          ? "danger"
          : status === "active"
            ? "success"
            : status === "inactive"
              ? "danger"
              : "primary";
    },
    openPage(event) {
      this.$router.push(event);
    },
    showModal(id) {
      this.$refs[id].show();
    },
    editCallModal(id, event) {
      this.$refs[id].show();
      this.getActivityId = event;
      // console.log(event)
      axios
        .get("crm/v1/leads_activities/" + event)
        .then(response => {
          this.editCall = response.data.data;
          // this.statusActivityCall(2)
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    editAppointmentModal(id, event) {
      this.$refs[id].show();
      this.getActivityId = event;
      // console.log(event)
      axios
        .get("crm/v1/leads_activities/" + event)
        .then(response => {
          this.editAppointment = response.data.data;
          // this.statusActivityAppointment(4)
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    hideModal(id) {
      this.$refs[id].hide();
    },
    todayNumber() {
      return moment().isoWeekday();
    },
    cutTime(value) {
      return value.slice(0, -3);
    },
    getNumberDay(value) {
      return moment(new Date(value)).isoWeekday();
    },
    parseDateTime(value) {
      moment.locale("en");
      return moment(new Date(value)).format("DD MMMM YYYY");
    },
    parseDateTime1(value) {
      moment.locale("en");
      return moment(new Date(value)).format("DD");
    },
    parseDateTime2(value) {
      moment.locale("en");
      return moment(new Date(value)).format("dddd");
    },
    parseDateTime3(value) {
      var curr = new Date();
      var first = curr.getDate() - curr.getDay();
      var monthName = new Date(curr.getTime());
      moment.locale("en");
      return moment(new Date(monthName)).format("MMMM YYYY");
    },
    parseImg(value) {
      return Auth.apiUrl + "crm/v1/img/banner/" + value;
    },
    // statusActivityCall (event = 2) {
    //   this.addCall.leads_activity_status_id = null
    //   axios.get('crm/v1/leads_activities_status?leads_activities_type_id=' + event).then(response => {
    //     this.data2 = response.data.data.rows
    //     // console.log('test', response.data.data.rows)
    //   }).catch(error => {
    //     console.log('error', error)
    //   })
    // },
    // statusActivityAppointment (event = 4) {
    //   this.addAppointment.leads_activity_status_id = null
    //   axios.get('crm/v1/leads_activities_status?leads_activities_type_id=' + event).then(response => {
    //     this.data3 = response.data.data.rows
    //     // console.log('test', response.data.data.rows)
    //   }).catch(error => {
    //     console.log('error', error)
    //   })
    // },
    fetchData() {
      this.id_lead = this.$route.query.id;
      this.regisPrivy.leads_id = this.$route.query.id;
      axios
        .get(
          "crm/v1/leads_activities?sales_id=" +
          Auth.Session.get().paradigm_id +
          "&leads_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage +
          "&limit=" +
          this.paginationLimit +
          "&sorting=" +
          this.sortBy +
          "&sorting_type=" +
          this.sortType +
          "&keyword=" +
          this.searchData +
          "&is_sales_planner=" +
          this.$route.query.is_sales_planner
        )
        .then(response => {
          this.items = response.data.data.rows;
          for (var i = 0; i < this.items.length; i++) {
            // console.log()
            if (this.items[i].leads_activities_status.name == "Interested") {
              this.validateInterested = "Interested";
              break;
            }
          }
          this.totalPage = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads/" + this.$route.query.id)
        .then(response => {
          this.dataMember = response.data.data;
          this.dataLeads = response.data.data;
          this.salesName = response.data.data.sale.fullname;

          this.isBlacklist = this.dataMember.is_blacklist === 1 ? true : false;
          if (
            response.data.data.doc_name === "form_paradigm_2.hbs" ||
            response.data.data.doc_name === "form_paradigm_3.hbs"
          ) {
            this.getDocType = "other";
          } else if (
            response.data.data.doc_name === "form_paradigm_1.hbs" ||
            response.data.data.doc_name === "form_paradigm_6.hbs"
          ) {
            this.getDocType = "self";
          } else {
            this.getDocType = "self";
          }
          // console.log('print', this.getDocType)
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "crm/v1/leads_eha_form/check_empty?leads_id=" + this.$route.query.id
        )
        .then(response => {
          this.formEmpty = response.data.empty_form;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads_activities_type?status=active")
        .then(response => {
          this.data1 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads_activities_status?leads_activities_type_id=2")
        .then(response => {
          this.data2 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads_activities_status?leads_activities_type_id=4")
        .then(response => {
          this.data3 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads/get_transaction?leads_id=" + this.$route.query.id)
        .then(response => {
          this.dataTransaction = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("transaction/v1/payment_card")
        .then(response => {
          this.itemsPaymentCard = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("transaction/v1/payment_type")
        .then(response => {
          this.itemsPaymentType = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

      // get leads flow
      axios
        .get("crm/v1/leads_activities/leads_flow?leads_id=" + this.$route.query.id)
        .then(response => {
          this.leadsFlow = response.data.data;
          console.log('test', response.data.data)
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.fetchData();

    const roleMapping = Auth.Session.get().paradigm_role_mapping_id
    const roleId = Auth.Session.get().paradigm_role
    if (roleMapping.includes(1712)) {
      this.isViewOnly = true
    } else if (Number(roleId) == 33) {
      this.isViewOnly = true
    }
  }
};
</script>
